import {
  SUPPLIER_PAGINATED,
  SUPPLIER_REGISTER,
  SUPPLIER_UPDATE,
  SUPPLIER_DELETE,
} from "../../../api/ApiEndpoints";
import api from "../../../interceptor/Interceptor";
import {
  fetchSuppliersStart,
  fetchSuppliersSuccess,
  fetchSuppliersFailure,
  addSupplierStart,
  addSupplierSuccess,
  addSupplierFailure,
  editSupplierStart,
  editSupplierSuccess,
  editSupplierFailure,
  deleteSuppliersStart,
  deleteSuppliersSuccess,
  deleteSuppliersFailure,
} from "../../reducer/supplierReducer/SupplierReducer";

let fetchSuppliersSeq = 0;
let isFetchSuppliers = false;
let isAddSupplier = false;
let isEditSupplier = false;
let isDeleteSuppliers = false;

const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;

// .................... List / Search ...........................

export const fetchSuppliers = (query = "", page = 1, pageSize = 10) => async (dispatch) => {
   if (isFetchSuppliers) return;
  isFetchSuppliers = true;
  const seq = ++fetchSuppliersSeq;
  dispatch(fetchSuppliersStart());
  try {
    const url = `${SUPPLIER_PAGINATED}?search=${encodeURIComponent(query || "")}&page=${page}&pageSize=${pageSize}`;
    const response = await api.get(url);
    if (seq !== fetchSuppliersSeq) return { success: true, stale: true };
    const pagination = response.data.pagination || { page, pageSize, totalItems: 0, totalPages: 1 };
    dispatch(fetchSuppliersSuccess({ list: response.data.suppliers || [], pagination }));
    return { success: true, pagination };
  } catch (error) {
    if (seq !== fetchSuppliersSeq) return { success: true, stale: true };
    const message = extractErrorMessage(error, "Failed to fetch suppliers");
    dispatch(fetchSuppliersFailure(message));
    return { success: false, error: message };
  } finally {
    isFetchSuppliers = false;
  }
};

// .................... Add ...........................

export const addSupplier = (newSupplier) => async (dispatch) => {
  if (isAddSupplier) return;
  isAddSupplier = true;
  dispatch(addSupplierStart());
  try {
    await api.post(SUPPLIER_REGISTER, newSupplier);
    dispatch(addSupplierSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to add supplier");
    dispatch(addSupplierFailure(message));
    return { success: false, error: message };
  } finally {
    isAddSupplier = false;
  }
};

// .................... Edit ...........................

export const editSupplier =
  (originalName, updatedSupplier) => async (dispatch) => {
    if (isEditSupplier) return;
    isEditSupplier = true;
    dispatch(editSupplierStart());
    try {
      await api.put(
        `${SUPPLIER_UPDATE}${encodeURIComponent(originalName)}`,
        updatedSupplier,
      );
      dispatch(editSupplierSuccess());
      return { success: true };
    } catch (error) {
      const message = extractErrorMessage(error, "Failed to update supplier");
      dispatch(editSupplierFailure(message));
      return { success: false, error: message };
    } finally {
      isEditSupplier = false;
    }
  };

// .................... Delete ...........................

export const deleteSuppliers = (names) => async (dispatch) => {
  if (isDeleteSuppliers) return;
  isDeleteSuppliers = true;
  dispatch(deleteSuppliersStart());
  try {
    await api.post(SUPPLIER_DELETE, { names });
    dispatch(deleteSuppliersSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to delete supplier(s)");
    dispatch(deleteSuppliersFailure(message));
    return { success: false, error: message };
  } finally {
    isDeleteSuppliers = false;
  }
};
